import React, { Component } from 'react'
import { browserHistory } from 'react-router'

import { Button } from '../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as modalActions from '../../actions/modal'

class RequestFormConfirmation extends Component {
    static propTypes = {
        modalActions: React.PropTypes.object.isRequired,
    }

    _redirectToCurrentJobs = () => {
        this.props.modalActions.hideModal()
        browserHistory.push('/jobs')
    }

    render() {
        return (
            <div>
                <p>
                    Thank you for requesting overtime. Please wait for a response to your request
                    before submitting this invoice.
                </p>

                <Button
                    buttonOnly
                    onClick={ this._redirectToCurrentJobs }
                    status="primary"
                >
                    Back to current jobs & billing
                </Button>
            </div>
        )
    }
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            jobs: state.jobs,
        }
    },
    (dispatch) => {
        return {
            modalActions: bindActionCreators(modalActions, dispatch),
        }
    }
)(RequestFormConfirmation)



// WEBPACK FOOTER //
// ./app/components/jobs/request_form_confirmation.js